module.exports = __webpack_public_path__ + "static/media/bajaj_auto_partner.5190120f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bajaj_auto_partner.webp
// module id = 322
// module chunks = 0